import React, { useState } from "react";
import { Home, Check, X } from "lucide-react";

export const HouseholdControl = ({ member, canEdit, isFamily, onSave }) => {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(member.householdId || "");
  const id = member.recordId;

  if (open) {
    return (
      <span className="flex items-center gap-1 shrink-0">
        <input data-testid={`cell-household-input-${id}`} autoFocus value={val} onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSave(val.trim()).then(() => setOpen(false))}
          placeholder="e.g. Smith" className="bg-[#EDF2F4] border border-[#EBE9E4] rounded-lg outline-none px-2 py-1 text-xs w-24" />
        <button data-testid={`cell-household-save-${id}`} onClick={() => onSave(val.trim()).then(() => setOpen(false))} className="rounded p-1 text-white" style={{ background: "var(--sj-primary)" }}><Check className="h-3 w-3" /></button>
        <button data-testid={`cell-household-cancel-${id}`} onClick={() => setOpen(false)} className="rounded p-1" style={{ color: "var(--sj-text-3)" }}><X className="h-3 w-3" /></button>
      </span>
    );
  }
  if (member.householdId) {
    return (
      <button data-testid={`cell-household-chip-${id}`} disabled={!canEdit} onClick={() => setOpen(true)} title={isFamily ? "Kept together with their household" : "Household ID"}
        className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded-full shrink-0"
        style={{ background: isFamily ? "#E3F1EC" : "#EDF2F4", color: isFamily ? "#0B5E4E" : "var(--sj-text-2)" }}>
        <Home className="h-3 w-3" /> {member.householdId}
      </button>
    );
  }
  return canEdit ? (
    <button data-testid={`cell-household-add-${id}`} onClick={() => setOpen(true)} title="Set household ID" className="rounded p-1 shrink-0 opacity-50 hover:opacity-100" style={{ color: "var(--sj-text-3)" }}>
      <Home className="h-3.5 w-3.5" />
    </button>
  ) : null;
};
